import { PairedCostRouteItem, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { OrderState } from '../../../../redux/types.ts';

export const getDepreciatedCostPageRoute = (order: OrderState): PairedCostRouteItem =>
  schPairedCostRouteItem.enum[order.isInspectifyOrder ? 'cost-approach' : 'analysis'];
